import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=422fcf96&scoped=true&"
import script from "./Register.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Register.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=422fcf96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422fcf96",
  null
  
)

export default component.exports